import React, { createContext, useContext, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

export type FormationAnswer = {
    questionId: number;
    answerId: number;
};

interface FormationProviderProps {
    children: React.ReactNode;
}

const FormationContext = createContext<FormationContextType | undefined>(undefined);

export type FormationContextType = {
    signature: string | null;
    setSignature: (signature: string) => void;
    requestUser: string | null;
    setRequestUser: (requestUser: string) => void;
    questionsAnswers: FormationAnswer[];
    setQuestionsAnswers: (answers: FormationAnswer[]) => void;
    score: number | null;
    setScore: (score: number) => void;
};

export const FormationProvider: React.FC<FormationProviderProps> = ({ children }) => {
    const [signature, setSignature] = useState<string | null>(null);
    const [requestUser, setRequestUser] = useState<string | null>(null);
    const [questionsAnswers, setQuestionsAnswers] = useState<FormationAnswer[]>([]);
    const [score, setScore] = useState<number | null>(null);
    const location = useLocation();

    useEffect(() => {
        if (!location.pathname.includes('/formations') || location.pathname === '/sante-securite/formations/list') {
            setRequestUser(null);
            setSignature(null);
            setQuestionsAnswers([]);
            setScore(null);
        }
    }, [location.pathname]);

    const value = {
        signature,
        setSignature,
        requestUser,
        setRequestUser,
        questionsAnswers,
        setQuestionsAnswers,
        score,
        setScore
    };

    return <FormationContext.Provider value={value}>{children}</FormationContext.Provider>;
};

// eslint-disable-next-line react-refresh/only-export-components
export const useFormation = () => {
    const context = useContext(FormationContext);
    if (context === undefined) {
        throw new Error('useFormation must be used within a FormationProvider');
    }

    return context;
};
